var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.68594 0.5 0 3.18594 0 6.5C0 9.81406 2.68594 12.5 6 12.5C9.31406 12.5 12 9.81406 12 6.5C12 3.18594 9.31406 0.5 6 0.5ZM6 11.375C3.31172 11.375 1.125 9.18805 1.125 6.5C1.125 3.81195 3.31172 1.625 6 1.625C8.68828 1.625 10.875 3.81195 10.875 6.5C10.875 9.18805 8.68828 11.375 6 11.375ZM6.9375 8.375H6.5625V6.3125C6.5625 6.00313 6.31172 5.75 6 5.75H5.25C4.94063 5.75 4.6875 6.00313 4.6875 6.3125C4.6875 6.62188 4.94063 6.875 5.25 6.875H5.4375V8.375H5.0625C4.75313 8.375 4.5 8.62813 4.5 8.9375C4.5 9.24687 4.75313 9.5 5.0625 9.5H6.9375C7.24805 9.5 7.5 9.24805 7.5 8.9375C7.5 8.62695 7.24922 8.375 6.9375 8.375ZM6 5C6.41414 5 6.75 4.66414 6.75 4.25C6.75 3.83586 6.41414 3.5 6 3.5C5.58586 3.5 5.25 3.83516 5.25 4.25C5.25 4.66484 5.58516 5 6 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.16c2871610a6a7ae2a41b5c952ae15c2.svg";
export { ForwardRef as ReactComponent };